import { forwardRef } from "react";

import { fieldVariants, type FieldVariants } from "./field.styles";

export type FieldRef = React.ComponentRef<"div">;

export interface FieldProps
  extends React.ComponentPropsWithoutRef<"div">, FieldVariants {}

const Field = forwardRef<FieldRef, FieldProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div {...props} className={fieldVariants({ className })} ref={ref}>
        {children}
      </div>
    );
  },
);

Field.displayName = "Field";

export { Field };
